import { useState, useEffect, useRef } from 'react'
import {
  StyleSheet,
  View,
  Modal,
  Animated,
  KeyboardAvoidingView,
  Platform,
  SafeAreaView,
  useWindowDimensions
} from 'react-native'

interface modalPopupProps {
  visible: boolean
  children: JSX.Element | JSX.Element[]
  position?: string
  screen?: string
  flatTop?: boolean
  flatBottom?: boolean
}

const ModalPopup = ({
  visible,
  children,
  position = 'center',
  screen,
  flatTop,
  flatBottom
}: modalPopupProps) => {
  const [showModal, setShowModal] = useState(visible)
  const scaleValue = useRef(new Animated.Value(0)).current

  const { width: DEVICE_WIDTH } = useWindowDimensions()

  useEffect(() => {
    toggleModal()
  }, [visible])

  const toggleModal = () => {
    if (visible) {
      setShowModal(true)
      Animated.spring(scaleValue, {
        toValue: 1,
        useNativeDriver: false
      }).start()
    } else {
      setTimeout(() => setShowModal(false), 200)
      Animated.timing(scaleValue, {
        toValue: 0,
        duration: 300,
        useNativeDriver: false
      }).start()
    }
  }
  return (
    <Modal transparent visible={showModal}>
      <SafeAreaView style={[{ flexGrow: 1 }]}>
        <KeyboardAvoidingView
          behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
          style={[{ flex: 1 }, DEVICE_WIDTH > 960 && styles.modalLargeScreen]}
        >
          <View
            style={[
              styles.modalBackGround,
              position === 'top'
                ? styles.modalBackGroundTop
                : position === 'bottom'
                  ? styles.modalBackGroundBottom
                  : {}
            ]}
          >
            <Animated.View
              style={[
                styles.modalContainer,
                screen === 'full'
                  ? styles.modalContainerFull
                  : screen === 'dropdown'
                    ? styles.modalContainerDropdown
                    : {},
                { transform: [{ scale: scaleValue }] },
                flatTop && styles.modalContainerTopFlat,
                flatBottom && styles.modalContainerBottomFlat
              ]}
            >
              {children}
            </Animated.View>
          </View>
        </KeyboardAvoidingView>
      </SafeAreaView>
    </Modal>
  )
}

const styles = StyleSheet.create({
  modalBackGround: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.5)',
    justifyContent: 'center',
    alignItems: 'center'
  },
  modalBackGroundTop: {
    justifyContent: 'flex-start'
  },
  modalBackGroundBottom: {
    justifyContent: 'flex-end'
  },
  modalContainer: {
    width: '90%',
    backgroundColor: 'white',
    borderRadius: 10,
    elevation: 20,
    // padding: 20
  },
  modalContainerFull: {
    width: '100%'
  },
  modalContainerDropdown: {
    width: '70%',
    marginVertical: 80
  },
  modalContainerBottomFlat: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  modalContainerTopFlat: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  },
  modalLargeScreen: {
    maxWidth: '50%',
    right: 0,
    position: 'absolute',
    width: '100%',
    height: '100%'
  }
})

export default ModalPopup
